import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import { Table } from "reactstrap";
import { fetchActiveEvents } from "../actions";
import Loader from "../../Common/loader";
import RenderList from "./list-item";
import LocaleStrings from "../../../languages";

const ActiveEvents = (props) => {
  var { session, pageNumber, ActiveEventList } = props;

  useEffect(() => {
    props.fetchActiveEvents(session);
  }, []);

  const paginationCallback = (no) => {
    props.operationsCallback(no);
  };

  const renderList = () => {
    let pageDataLength = ActiveEventList?.data
      ? ActiveEventList?.data?.length
      : 0;

    return _.map(ActiveEventList.data, (item, index) => {
      return (
        <RenderList
          key={`key_${index}`}
          printList={item}
          pageDataLength={pageDataLength}
          currentPage={pageNumber}
          pagination={paginationCallback}
        />
      );
    });
  };

  return (
    <>
      {ActiveEventList?.data ? (
        <>
          {ActiveEventList?.count > 0 ? (
            <Table className="align-items-center table-flush" responsive>
              <thead className="thead-light">
                <tr>
                  <th scope="col">{LocaleStrings.events_th_eventid}</th>
                  <th scope="col">{LocaleStrings.events_th_event_name}</th>
                  <th scope="col">{LocaleStrings.events_th_event_type}</th>
                  <th scope="col">
                    {LocaleStrings.events_th_event_active_start}
                  </th>
                  <th scope="col">
                    {LocaleStrings.events_th_event_active_end}
                  </th>
                  <th scope="col" />
                </tr>
              </thead>
              <tbody>{renderList()}</tbody>
            </Table>
          ) : (
            <div className="no-content-message">
              <div>
                <div className="no-content-text">
                  {LocaleStrings.events_text_no_active_data}
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        <Loader />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  // console.log("state.ActiveEventList :- ", state.ActiveEventList);

  return {
    session: state.session,
    ActiveEventList: state.ActiveEventList,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ fetchActiveEvents }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ActiveEvents);
